export default __webpack_public_path__ + "locales/de/MainBar.json?hash=3c15cfde8781cca0af35ffc5a5f83d83";